// filepath: /Users/iulian/mCode/b2x-front/src/components/admin/properties/PropertyModal.js
import React from "react";
import { Modal, Form, Button } from "react-bootstrap";

const PropertyModal = ({ show, handleClose, formValues, onInputChange, onSubmit, editing }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{editing ? "Modifică parametru" : "Adaugă parametru"}</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formValues);
        }}
      >
        <Modal.Body>
          <Form.Group className="mb-3" controlId="modalPropertyName">
            <Form.Label>Nume parametru</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formValues.name}
              onChange={onInputChange}
              placeholder="Introduceți numele parametrului"
              disabled={editing} // Dezactivează când se editează pentru a păstra identificatorul fix
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="modalPropertyValue">
            <Form.Label>Valoare parametru</Form.Label>
            <Form.Control
              type="text"
              name="value"
              value={formValues.value}
              onChange={onInputChange}
              placeholder="Introduceți valoarea parametrului"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Anulează
          </Button>
          <Button variant="primary" type="submit">
            {editing ? "Actualizează Setări" : "Adaugă Setări"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default PropertyModal;